import styled, {css} from 'styled-components'

const Style = {
	Wrapper: styled.div`
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;

		& > h1 {
			${({theme}) => theme.font.large};
			margin-bottom: 8px;
		}

		& > h2 {
			${({theme}) => theme.font.extra_small};
			margin-bottom: 4px;
		}

		& > p {
			${({theme}) => theme.font.heading};
			color: ${({theme}) => theme.color.major};
		}

		& > img {
			width: 520px;
			margin: 24px 0 32px 0;
		}
	`,
}
export default Style
